<app-research-list [researchOverviewList]="data"></app-research-list>
